import React from 'react'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import Paper from '@mui/material/Paper'

const Oedema = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12} lg={4}>
    <Autocomplete
      value={moduleValues?.['Oedema'] ?? []}
      options={[
        'No Oedema',
        'Peripheral Oedema',
        'Pitting Oedema',
        'Non-Pitting Oedema',
        'Bilateral Oedema',
        'Unilateral Oedema',
        'Generalized Oedema',
        'Ankle Oedema',
        'Lower Leg Oedema',
        'Upper Leg Oedema',
        'Arm Oedema',
        'Facial Oedema',
        'Scrotal Oedema',
        'Other (Specify)',
      ]}
      multiple
      freeSolo
      onChange={(e, value) =>
        setModuleValues((prev) => ({ ...prev, ['Oedema']: value }))
      }
      renderInput={(params) => <TextField {...params} label="Oedema" />}
    />
  </Grid>
)

export default Oedema
